import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DocumentTypeCustomField, DocumentTypeDTO } from 'src/app/pages/dashboards/files-clients/interface/company-document.interface';
import { AddCustomFieldDTO, CreateOrUpdateDocumentTypeRequest } from '../../interfaces/create-update-document-type.interface';
import { DocumentTypeService } from '../../services/document-type.service';
import Swal from 'sweetalert2';

export const noDuplicateFieldNameValidator: ValidatorFn = (formArray: AbstractControl): ValidationErrors | null => {
  const names = (formArray as FormArray).controls.map(c => c.get('fieldName')?.value.toLowerCase());
  const hasDuplicated = names.some((name, index) => names.indexOf(name.toLowerCase()) !== index);
  return hasDuplicated ? {duplicateNames: true} : null;
}

@Component({
  selector: 'app-create-or-update-document-type-modal',
  templateUrl: './create-or-update-document-type-modal.component.html',
  styleUrls: ['./create-or-update-document-type-modal.component.scss']
})
export class CreateOrUpdateDocumentTypeModalComponent implements OnInit {

  public createUpdateDocTypeFormGroup: FormGroup;
  public availableTypes = [
    {
      value: 0, text: 'Texto'
    },{
      value: 1, text: 'Fecha',
    },
    {
      value: 2, text: 'Numero',
    }
  ]

  public modalTitle: string = '';
  public submitText: string = '';

  constructor(private dialogRef: MatDialogRef<CreateOrUpdateDocumentTypeModalComponent>,
    @Inject(MAT_DIALOG_DATA)public data: DocumentTypeDTO | null,
    private documentTypeService: DocumentTypeService,
    private fb: FormBuilder
  ){
    this.createUpdateDocTypeFormGroup = this.fb.group({
      documentTypeId: [null],
      name: ['', Validators.required],
      description: [''],
      customFields: this.fb.array([], noDuplicateFieldNameValidator)
    });

    this.modalTitle = data ? 'Actualizar Documento' : 'Nuevo documento';
    this.submitText = data ? 'Actualizar' : 'Registrar'
  }

  ngOnInit(): void {
    if(this.data) {
      const {documentTypeId ,documentName, documentDescription, customFields} = this.data
      this.createUpdateDocTypeFormGroup.patchValue({
        documentTypeId: documentTypeId,
        name: documentName,
        description: documentDescription,
      });
      customFields.forEach(cf => {
        const group = this.populateCustomFieldForm(cf);
        this.customFields.push(group);
      });
    }
  }

  populateCustomFieldForm(customField: DocumentTypeCustomField){
    const {name, typeField, required} = customField;
    return this.fb.group({
      fieldName: [name, Validators.required],
      typeField: [typeField, Validators.required],
      required: [required]
    });
  }

  closeDialog(){
    this.dialogRef.close(false);
  }

  get customFields() {
    return this.createUpdateDocTypeFormGroup.get('customFields') as FormArray;
  }

  addCustomField(){
    const customField = this.fb.group({
      fieldName: ['', Validators.required],
      typeField: [0, Validators.required],
      required: [false]
    })
    this.customFields.push(customField);
  }

  removeCustomField(index: number) {
    this.customFields.removeAt(index);
  }

  submit() {
    const {documentTypeId, name, description} = this.createUpdateDocTypeFormGroup.value;
    const customFields: AddCustomFieldDTO[] = this.customFields.value.map(c =>{
      return <AddCustomFieldDTO> {
        fieldName: c.fieldName,
        fieldType: c.typeField,
        isRequired: c.required
      }
    });
    const request: CreateOrUpdateDocumentTypeRequest = {
      name: name,
      description: description,
      customFields: customFields
    };
    
    const createUpdateRequest$ = documentTypeId != null
    ? this.documentTypeService.updateCompanyDocumentType(documentTypeId, request)
    : this.documentTypeService.createDocumentType(request);

    createUpdateRequest$.subscribe({
      next:(res) => {
        Swal.fire({
          title: 'Operación exitosa',
          text: res.resultMessage,
          icon: 'success',
          allowOutsideClick: false,
          showConfirmButton: true,
          confirmButtonText: 'Ok'
        }).then((r) => {
          if(r.isConfirmed){
            this.dialogRef.close(true);
          }
        });
      },
      error: (err) => {
        Swal.fire({
          title: 'Operación fallida',
          text: err.error.resultMessage || 'Ha ocurrido un error',
          icon: 'error'
        });
      }
    })

  }
}
